'use client';
import Receipt from '@/app/_components/ui/icons/Receipt.svg';
import Toman from '@/app/_components/ui/icons/Toman.svg';
import PriceUnit from '../share/PriceUnit';

export default function CartTotals({
  page,
  nextpageHandler,
  total,
  profit,
  totalNumber,
  discount,
  totalWithoutDis,
}) {
  return (
    <>
      <div className="bg-light-gray-100 p-4 mt-4 md:mt-0 text-sm rounded-md">
        <div className="flex mb-4 font-bold items-center">
          <Receipt />
          <span className="pr-2 text-base">سفارش شما</span>
        </div>
        {totalNumber ? (
          <>
            {totalWithoutDis && (
              <div className="flex justify-between py-2 relative cartRow">
                <div className="text-color-price bg-light-gray-100 relative p-1">
                  قیمت کالاها
                  <span className="pr-1">{`(${totalNumber})`}</span>
                </div>

                <div className="bg-light-gray-100 relative  p-1 flex items-center">
                  <PriceUnit price={totalWithoutDis} />
                </div>
              </div>
            )}
            {discount > 0 && (
              <div className="flex  justify-between py-2 relative cartRow green-heavy">
                <div className="text-green-heavy bg-light-gray-100 relative  p-1">
                  کد تخفیف
                </div>
                <div className=" flex items-center relative bg-light-gray-100 ">
                  <div className="text-green-heavy   p-1 flex items-center">
                    <span>{discount.toLocaleString('fa-IR')}</span>
                    <Toman fill="#08A54A" />
                  </div>
                </div>
              </div>
            )}
            {profit > 0 && (
              <div className="flex  justify-between py-2 relative cartRow color-primary">
                <div className="text-color-primary bg-light-gray-100 relative  p-1">
                  سود شما از این خرید
                </div>
                <div className="bg-light-gray-100 text-color-primary relative  p-1 flex items-center">
                  <span>{profit.toLocaleString('fa-IR')}</span>
                  <Toman fill="#2A75BB" />
                </div>
              </div>
            )}
            {total && (
              <>
                <div className="border-t border-light-gray-400 h-[2px] my-4"></div>
                <div className="flex  justify-between py-2 relative font-bold cartRow">
                  <div className="bg-light-gray-100 relative  p-1">مجموع</div>
                  <div className="bg-light-gray-100 relative  p-1 flex items-center">
                    <PriceUnit price={total} />
                  </div>
                </div>
              </>
            )}
            <div>
              <button
                className="w-full bg-color-primary hover:shadow-primary transition text-white py-3 rounded-md text-sm mt-6"
                type="button"
                onClick={nextpageHandler}
              >
                {page == 'payment' ? 'پرداخت' : 'ادامه'}
              </button>
            </div>
          </>
        ) : (
          <>سبد خرید شما خالی است</>
        )}
      </div>
    </>
  );
}
